import { render, staticRenderFns } from "./Annotator.vue?vue&type=template&id=7092fdb5&scoped=true&"
import script from "./Annotator.vue?vue&type=script&lang=js&"
export * from "./Annotator.vue?vue&type=script&lang=js&"
import style0 from "./Annotator.vue?vue&type=style&index=0&id=7092fdb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7092fdb5",
  null
  
)

component.options.__file = "Annotator.vue"
export default component.exports